import * as actionType from "./ActionTypes";

export default function EmailRecepientsReducer(state = {}, action) {
    const { payload } = action;
    switch (action.type) {
    case actionType.EMAIL_RECEPIENTS :
        return (state = payload);

    default:
        return state;
    }
    
}
